import React, { Component } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faQrcode, faLink, faCheck } from '@fortawesome/free-solid-svg-icons';
import { Navigate } from 'react-router-dom';
import QRCode from 'qrcode';
import SwalServices from '../../services/swalServices/SwalServices';
import AdminServices from '../../services/axiosServices/apiServices/adminServices';
import { CommonSuccessMessages } from '../../utils/Messages';
import { encryptForWebsite } from '../../utils/Encryption';
import { WebPath } from '../../utils/AppSetting';

const buildLogbookUrl = (houseid) =>
    `${WebPath.replace(/\/$/, '')}/logbooks?h=${encryptForWebsite(houseid)}`;

export default class HouseMasterList extends Component {
    constructor(props) {
        super(props);
        this.swalServices = new SwalServices();
        this.adminServices = new AdminServices();
        this.state = {
            houseList: [],
            isLoading: false,
            globalFilter: '',
            cityFilter: '',
            route: null,
            filterDetails: {
                start: 0,
                length: -1,
                search: '',
                sortField: '',
                sortOrder: 'asc',
            },
            qrModal: null,
            copiedId: null,
        };
    }

    componentDidMount() {
        this.getHouseList();
    }

    getHouseList = () => {
        const { filterDetails } = this.state;
        const request = [
            filterDetails.start,
            filterDetails.length,
            filterDetails.search,
            filterDetails.sortField,
            filterDetails.sortOrder,
        ];
        this.setState({ isLoading: true });
        this.adminServices.getHouseList(request).then((response) => {
            if (response && response.data) {
                this.setState({ houseList: response.data });
            }
            this.setState({ isLoading: false });
        });
    };

    handleEdit = (rowData) => {
        if (rowData.houseid && rowData.houseid > 0) {
            this.setState({ route: '/house-details?=' + rowData.houseid });
        }
    };

    handleDelete = (rowData) => {
        if (rowData.houseid && rowData.houseid > 0) {
            this.swalServices.Confirm(
                '', '',
                CommonSuccessMessages.Yes_Text,
                CommonSuccessMessages.No_Text,
                'Are you sure you want to delete this house?'
            ).then((confirmed) => {
                if (confirmed) {
                    this.adminServices.deleteHouse(rowData.houseid).then((response) => {
                        if (response.success === 1) {
                            this.swalServices.Success(response.msg);
                            this.getHouseList();
                        } else {
                            this.swalServices.Error(response.msg);
                        }
                    });
                }
            });
        }
    };

    handleShowQr = async (rowData) => {
        const url = buildLogbookUrl(rowData.houseid);
        const dataUrl = await QRCode.toDataURL(url, {
            width: 260,
            margin: 2,
            color: { dark: '#000000', light: '#ffffff' },
        });
        this.setState({ qrModal: { url, dataUrl, housename: rowData.housename } });
    };

    handleCopyLink = (rowData) => {
        const url = buildLogbookUrl(rowData.houseid);
        navigator.clipboard.writeText(url).then(() => {
            this.setState({ copiedId: rowData.houseid });
            setTimeout(() => this.setState({ copiedId: null }), 2000);
        }).catch(() => {
            this.swalServices.Error('Failed to copy link.');
        });
    };

    downloadQr = () => {
        const { qrModal } = this.state;
        if (!qrModal) return;
        const a = document.createElement('a');
        a.href = qrModal.dataUrl;
        a.download = `logbook-qr-${qrModal.housename.replace(/\s+/g, '-').toLowerCase()}.png`;
        a.click();
    };

    actionBodyTemplate = (rowData) => {
        const isCopied = this.state.copiedId === rowData.houseid;
        const iconBtnStyle = { width: '2rem', height: '2rem', padding: 0, border: 'none', background: 'transparent', cursor: 'pointer', color: '#6c757d', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' };
        return (
            <div className="flex gap-1 justify-center items-center">
                <button onClick={() => this.handleShowQr(rowData)} title="Logbook QR Code" style={iconBtnStyle}>
                    <FontAwesomeIcon icon={faQrcode} style={{ fontSize: '14px' }} />
                </button>

                <button
                    onClick={() => this.handleCopyLink(rowData)}
                    title={isCopied ? 'Copied!' : 'Copy Logbook Link'}
                    style={{ ...iconBtnStyle, color: isCopied ? '#22c55e' : '#6c757d' }}
                >
                    <FontAwesomeIcon icon={isCopied ? faCheck : faLink} style={{ fontSize: '14px' }} />
                </button>

                <Button
                    icon="pi pi-pencil"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleEdit(rowData)}
                    tooltip="Edit"
                    tooltipOptions={{ position: 'top' }}
                />

                <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-text p-button-sm"
                    style={{ width: '2rem', height: '2rem', padding: 0 }}
                    onClick={() => this.handleDelete(rowData)}
                    tooltip="Delete"
                    tooltipOptions={{ position: 'top' }}
                />
            </div>
        );
    };

    render() {
        if (this.state.route != null) return <Navigate to={this.state.route} />;
        const { qrModal, houseList, globalFilter, cityFilter } = this.state;

        const cities = [...new Set(houseList.map((h) => h.housecity).filter(Boolean))].sort();
        const filteredList = cityFilter
            ? houseList.filter((h) => h.housecity === cityFilter)
            : houseList;

        return (
            <div className="house-master-list" style={{ height: 'calc((100dvh / 0.85) - 45.8px)' }}>
                <div className="house-master-list-inner h-full p-[30px] overflow-y-auto">
                    <div className="title flex items-center justify-between mb-[10px]">
                        <h1 className="text-[22px] m-0 font-semibold text-[#004AAD]" style={{ lineHeight: '30px' }}>
                            House Master
                        </h1>
                        <button
                            onClick={() => this.setState({ route: '/house-details' })}
                            className="flex items-center gap-[5px] py-[5px] px-[10px] text-[14px] font-medium rounded-[5px] text-[#FFFFFF] bg-[#0077B6] hover:bg-[#3b82f6] border-0"
                        >
                            <FontAwesomeIcon className="w-5 h-5" icon={faPlus} />
                            Add New House
                        </button>
                    </div>

                    <div className="house-table p-5 bg-white rounded-[16px]" style={{ border: '1px solid #DFDFDF' }}>
                        <div className="table-inner grid grid-cols-3 gap-5 items-end mb-[20px]">
                            <div className="input-grp !mb-0">
                                <label>Search</label>
                                <InputText
                                    type="search"
                                    value={globalFilter}
                                    onChange={(e) => this.setState({ globalFilter: e.target.value })}
                                    placeholder="Search across all columns..."
                                />
                            </div>
                            <div className="input-grp !mb-0">
                                <label>Filter by City</label>
                                <select
                                    value={cityFilter}
                                    onChange={(e) => this.setState({ cityFilter: e.target.value })}
                                >
                                    <option value="">All Cities</option>
                                    {cities.map((city) => (
                                        <option key={city} value={city}>{city}</option>
                                    ))}
                                </select>
                            </div>
                            <Button
                                label="Reset filters"
                                className="w-fit h-fit"
                                onClick={() => this.setState({ globalFilter: '', cityFilter: '' })}
                                style={{ fontWeight: '400', lineHeight: '1' }}
                            />
                        </div>

                        <div className="sub-table rounded-xl shadow-sm overflow-hidden border border-gray-200 bg-white">
                            <DataTable
                                value={filteredList}
                                paginator
                                rows={50}
                                responsiveLayout="scroll"
                                scrollable
                                scrollHeight="calc((100dvh / 0.85) - 420px)"
                                className="min-w-full"
                                globalFilter={globalFilter}
                                emptyMessage="No houses found"
                                loading={this.state.isLoading}
                                loadingIcon={
                                    <div className="flex justify-center items-center w-full py-4">
                                        <ProgressSpinner style={{ width: '40px', height: '40px' }} strokeWidth="4" />
                                    </div>
                                }
                            >
                                <Column header="Sr No" body={(rowData, options) => options.rowIndex + 1} headerClassName="bg-blue-50 text-blue-800 font-medium" style={{ width: '5rem' }} />
                                <Column field="housename" header="House Name" sortable headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="housecity" header="City" sortable headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="housephone" header="Phone" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="housecontactemail" header="House Email" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="houseemail" header="Notification Emails" headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="createddate" header="Created Date" sortable headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column field="createdby" header="Created By" sortable headerClassName="bg-blue-50 text-blue-800 font-medium" />
                                <Column
                                    header="Actions"
                                    body={this.actionBodyTemplate}
                                    style={{ textAlign: 'center', width: '13rem' }}
                                    headerClassName="bg-blue-50 text-blue-800 font-medium"
                                />
                            </DataTable>
                        </div>
                    </div>
                </div>

                {/* QR Code Modal */}
                {qrModal && (
                    <div
                        className="fixed inset-0 flex items-center justify-center z-50 px-4"
                        style={{ background: 'rgba(0,0,0,0.5)' }}
                        onClick={(e) => { if (e.target === e.currentTarget) this.setState({ qrModal: null }); }}
                    >
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-sm p-6 text-center">
                            <h3 className="text-lg font-bold text-[#004AAD] mb-1">Logbook QR Code</h3>
                            <p className="text-sm text-gray-500 mb-4">{qrModal.housename}</p>
                            <img src={qrModal.dataUrl} alt="QR Code" className="mx-auto mb-3 rounded-lg" style={{ width: 220, height: 220 }} />
                            <p className="text-xs text-gray-400 mb-4 px-2" style={{ wordBreak: 'break-all' }}>{qrModal.url}</p>
                            <div className="flex gap-3">
                                <button
                                    onClick={this.downloadQr}
                                    className="flex-1 py-2 rounded-lg bg-[#004AAD] text-white text-sm font-semibold hover:bg-[#0077B6] transition-colors"
                                >
                                    Download QR
                                </button>
                                <button
                                    onClick={() => this.setState({ qrModal: null })}
                                    className="flex-1 py-2 rounded-lg border border-gray-300 text-gray-600 text-sm font-semibold hover:bg-gray-50 transition-colors"
                                >
                                    Close
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
